import style from './index.module.scss';
import { EditableImg } from '@smartfire/components';
import FooterButton from './footerButton';
import ContactInfos from './contact-infos';
import NavMenu from './nav-menu';
import { useEditor } from '@smartfire/js-block-engine';

function MainFooter({ menu, btnLink, btnText, tel, linkLinkedin }) {
    const { isEditing } = useEditor();
    return (
        <div className={style.background}>
            <div className={style.firstLine}>
                <a href={!isEditing && '/'}>
                    <EditableImg smartProp={'logo'} className={style.logo} />
                </a>
                <FooterButton text={btnText} link={btnLink} />
            </div>
            <div className={style.separator} />
            <div className={style.secondLine}>
                <ContactInfos tel={tel} linkLinkedin={linkLinkedin} />
                <NavMenu menu={menu} />
            </div>
        </div>
    );
}

export default MainFooter;
